import { State, Effect, dispatch, Actions } from 'jumpstate'
import { showLoading, hideLoading } from 'react-redux-loading-bar'
import axios from 'axios'
import apiAddress from '../utils/APIEndPointAddress'
import qs from 'qs'

const SearchState = State({
  initial: {
    keyword: {},
    horseResult: [],
    breederBox: null,
    breederResult: [],
    horseResultPage: null,
    breederResultPage: null
  },
  setHorseResult (state, payload) {
    return {
      ...state,
      keyword: payload.term,
      horseResult: payload.horseResult,
      horseResultPage: payload.page
    }
  },
  setBreederBoxResult (state, payload) {
    return {
      ...state,
      keyword: payload.keyword,
      breederBox: payload.breeders
    }
  },
  setBreederResult (state, payload) {
    return {
      ...state,
      keyword: payload.term,
      breederResult: payload.breederResult,
      breederResultPage: payload.page
    }
  },
  setSearchResult (state, payload) {
    return {
      ...state,
      ...payload
    }
  },
  getSearchResult (state, payload) {
    return state
  }
})

// eslint-disable-next-line
const autocompleteHorseEffect = Effect('autocompleteHorse', (keyword) => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  let urlParams = '?' + qs.stringify({term: keyword})
  return axios.get(apiAddress + `horse/auto-complete-search${urlParams}`)
})

// eslint-disable-next-line
const autocompleteHorseWithBasicDataEffect = Effect('autocompleteHorseWithBasicData', (keyword) => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  let urlParams = '?' + qs.stringify({term: keyword})
  return axios.get(apiAddress + `horse/auto-complete-all${urlParams}`)
})

// eslint-disable-next-line
const searchHorseEffect = Effect('searchHorse', (params) => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  let urlParams = '?' + qs.stringify({q: params.term, page: params.page})
  return axios.get(apiAddress + `horse/search${urlParams}`).then((res) => {
    Actions.setHorseResult({
      term: params.term,
      horseResult: res.data,
      page: params.page
    })
    return res
  }).catch(e => {
    return Promise.reject(e)
  })
})

// eslint-disable-next-line
const takeBreederBoxResultEffect = Effect('takeBreederBoxResult', (keyword) => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  let urlParams = '?' + qs.stringify({q: keyword})
  return axios.get(apiAddress + `breeder/search${urlParams}`).then((res) => {
    Actions.setBreederBoxResult({keyword: keyword, breeders: res.data})
    return res
  }).catch(e => {
    Actions.setBreederBoxResult({keyword: keyword, breeders: null})
    return Promise.reject(e)
  })
})

// eslint-disable-next-line
const searchBreederEffect = Effect('searchBreeder', (params) => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  let urlParams = '?' + qs.stringify({q: params.term, page: params.page})
  return axios.get(apiAddress + `breeder/greedy-search${urlParams}`).then((res) => {
    Actions.setBreederResult({term: params.term, breederResult: res.data, page: params.page})
    return res
  }).catch(e => {
    return Promise.reject(e)
  })
})

export default SearchState



// WEBPACK FOOTER //
// ./src/states/search.js